export default __webpack_public_path__ + "static/media/opensea.47c3ab4d.svg";